/**
 * @module modules/anomalies-table-sk/triage-api
 * @description Standalone utility to make edit anomaly requests to the backend.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "makeEditAnomalyRequest", {
    enumerable: true,
    get: function() {
        return makeEditAnomalyRequest;
    }
});
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _errorMessage = require("../errorMessage");
async function makeEditAnomalyRequest(anomalies, traceNames, editAction) {
    const keys = anomalies.map((a)=>a.id);
    const body = {
        keys: keys,
        trace_names: traceNames,
        action: editAction
    };
    try {
        const response = await fetch('/_/triage/edit_anomalies', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        await (0, _jsonOrThrow.jsonOrThrow)(response);
        let bug_id = null;
        if (editAction === 'RESET') {
            bug_id = 0;
        } else if (editAction === 'IGNORE') {
            bug_id = -2;
        }
        if (bug_id !== null) {
            for(let i = 0; i < anomalies.length; i++){
                anomalies[i].bug_id = bug_id;
            }
        }
    } catch (error) {
        (0, _errorMessage.errorMessage)('Edit anomalies request failed due to an internal server error. Please try again.');
        throw error;
    }
}
